/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

/* eslint-disable no-duplicate-imports */
import * as React from 'react';

import { IProductCollectionViewProps } from './c-product-collection';
import { getProductPageUrlSync } from '@msdyn365-commerce-modules/retail-actions';
import { SimpleProduct } from '@msdyn365-commerce/retail-proxy';
import { getByIdsAsync } from '@msdyn365-commerce/retail-proxy/dist/DataActions/ProductsDataActions.g';
import { Heading } from '@msdyn365-commerce-modules/utilities';

const ProductCollectionView: React.FC<IProductCollectionViewProps> = props => {
    const { config } = props;
    const intlFormatter = props.context.cultureFormatter;

    const getPrice = (price: number | undefined) => {
        if (typeof price !== 'undefined') {
            return intlFormatter.formatCurrency(price);
        } else {
            return '';
        }
    };

    // const getImageUrl = (imageUrl: string | undefined) => {
    //     return generateImageUrl(imageUrl, props.context.request.apiSettings) as string;
    // };

    const getProductPageUrl = (name: string | undefined, recordId: string | number | undefined) => {
        return getProductPageUrlSync(name as string, recordId as number, props.context.actionContext);
    };

    const [productss, setProducts] = React.useState<SimpleProduct[]>([]);
    const [productIds, setProductIds] = React.useState<number[]>([]);

    const iContext = {
        callerContext: props.context.actionContext
    };

    const apiSettings = props.context.request.apiSettings;

    React.useEffect(() => {
        if (config.productCollection.products && config.productCollection.products.length > 0) {
            const recordIds = config.productCollection.products.map((product: any) => product.RecordId);
            setProductIds(recordIds);
        }
    }, []);
    React.useEffect(() => {
        if (productIds.length > 0) {
            void getByIdsAsync(iContext, apiSettings.channelId, productIds).then(res => {
                setProducts(res);
            });
        }
    }, [productIds, config.productCollection.products]);

    return (
        <div className='productlist-padding'>
            <div className='productlist-title'>
                <Heading {...config.heading!} />
            </div>
            <div className='ms-search-result-container__Products'>
                <div className='msc-search-result-container-list'>
                    <ul className='list-unstyled'>
                        {config &&
                            config.productCollection &&
                            config.productCollection.products &&
                            config.productCollection.products.length > 0 &&
                            config.productCollection.products.map(product => {
                                return (
                                    <li key={product.ItemId} className='ms-product-search-result__item'>
                                        <a
                                            href={getProductPageUrl(product.Name, product.RecordId)}
                                            className='msc-product'
                                            data-exp-event-id={`Category.Search result container.${product.RecordId}.click`}
                                        >
                                            <div className='msc-product__image'>
                                                <picture>
                                                    <img
                                                        alt={product.Name}
                                                        src={`${product.PrimaryImageUrl}`}
                                                        data-src={`${product.PrimaryImageUrl}`}
                                                        className='msc-main_image msc_image lazyloaded'
                                                    />
                                                </picture>
                                            </div>
                                            <h4 className='msc-product__title'>{product.Name}</h4>
                                        </a>
                                        <div className='msc-product__reviews'>
                                            <div className='msc-rating msc-no-ratings ms-rating-component__up'>
                                                <p aria-hidden='true' className='msc-rating__count'>
                                                    Reviews ({product.TotalRatings})
                                                </p>
                                                <div className='msc-rating__range sr-only'></div>
                                                <div aria-hidden='true' className='msc-rating__group'>
                                                    {product.AverageRating
                                                        ? [1, 2, 3, 4, 5].map(item => {
                                                              return (
                                                                  <span
                                                                      key={item}
                                                                      className={` ${
                                                                          item > (product.AverageRating ? product.AverageRating : 0)
                                                                              ? 'msc-rating__empty-star'
                                                                              : 'msc-rating__star'
                                                                      }`}
                                                                      data-index={item}
                                                                      role='presentation'
                                                                  ></span>
                                                              );
                                                          })
                                                        : [1, 2, 3, 4, 5].map(item => {
                                                              return (
                                                                  <span
                                                                      key={item}
                                                                      className={`msc-rating__empty-star`}
                                                                      data-index={item}
                                                                      role='presentation'
                                                                  ></span>
                                                              );
                                                          })}
                                                </div>
                                            </div>
                                            <div className='msc-product__details'>
                                                <span className='msc-price'>
                                                    <p className='msc-price__actual' itemProp='price'>
                                                        {getPrice(product.Price)}
                                                    </p>
                                                    <p style={{ fontSize: 'small', textAlign: 'right' }}>
                                                        {config.excludeVatLabel
                                                            ? config.excludeVatLabel.length > 0
                                                                ? `(${config.excludeVatLabel})`
                                                                : ''
                                                            : ''}
                                                    </p>
                                                </span>
                                            </div>
                                        </div>
                                        <div className={`ml-product__buttons`} data-label={product.RecordId}>
                                            {productss.find(val => val.RecordId === product.RecordId)?.ExtensionProperties &&
                                            productss
                                                .find(val => val.RecordId === product.RecordId)
                                                ?.ExtensionProperties?.find(prop => prop.Key === 'INSSAMPLEITEMID')?.Value?.StringValue ? (
                                                <a
                                                    href={
                                                        productss
                                                            .find(val => val.RecordId === product.RecordId)
                                                            ?.ExtensionProperties?.find(prop => prop.Key === 'INSSAMPLEITEMID')?.Value
                                                            ?.StringValue
                                                    }
                                                    className='ml-product__sample-button'
                                                >
                                                    Order Sample
                                                    {/* {resources.orderSample} */}
                                                </a>
                                            ) : (
                                                <></>
                                            )}
                                        </div>
                                    </li>
                                );
                            })}
                    </ul>
                </div>
            </div>
        </div>
    );
};

export default ProductCollectionView;
